import { render, staticRenderFns } from "./Launcher.vue?vue&type=template&id=bc93369c&scoped=true"
import script from "./Launcher.vue?vue&type=script&lang=ts&setup=true"
export * from "./Launcher.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc93369c",
  null
  
)

export default component.exports